<form
	#paymentReceiptForm="ngForm"
	(ngSubmit)="save(paymentReceiptForm)"
	class="flex flex-col form"
>
	<app-input
		label="Description"
		[(ngModel)]="customItem.description"
		[required]="true"
		[submitted]="submitted"
		name="description"
		[testHook]="testHooks.Description"
	></app-input>
	<app-input
		type="cents"
		label="Amount"
		class="my-5"
		[(ngModel)]="customItem.amount"
		[required]="true"
		[submitted]="submitted"
		name="amount"
		[testHook]="testHooks.Amount"
	></app-input>
	<app-date-picker
		label="Date paid"
		[(ngModel)]="customItem.date"
		name="datepicker"
		[testHook]="testHooks.DatePaidDatePicker"
	></app-date-picker>

	<div class="flex w-full justify-between mt-52">
		<app-button
			size="small"
			btn="secondary"
			(click)="cancel()"
			[testHook]="testHooks.CancelButton"
			>Cancel</app-button
		>
		<app-button size="small" type="submit" [testHook]="testHooks.SaveButton"
			>Save</app-button
		>
	</div>
</form>
